import Crud from '../views/CompanionType/Crud'
import Entity from '../views/CompanionType/Add'

let routes = {
    path: '/companion_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/companion_types/add',
            name: 'NewCompanionType',
            component: Entity,
            meta: {
                pageTitle: 'companionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'companionType.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companion_types/edit/:id?',
            name: 'EditCompanionType',
            component: Entity,
            meta: {
                pageTitle: 'companionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'companionType.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companion_types',
            name: 'list-companion-types',
            component: Crud,
            meta: {
                pageTitle: 'companionType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'companionType.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
